import { PageRoutes } from './page-routes';
import { PageStore } from './page-store';
import type { TFunction } from 'i18next';

// Use the exact translation key type from i18next - this will be a union of all valid keys
type I18nKey = Parameters<TFunction<['home', 'common'], undefined>>[0];

// Filter out the complex types (arrays, template strings) to get just string literals
export type TranslationKey = Exclude<
  I18nKey,
  string | TemplateStringsArray | string[]
>[0];

export interface Page {
  title: TranslationKey;
  subtitle?: TranslationKey;
  path: PageRoutes;
  heroImage: string;
  heroImageAlt: TranslationKey;
  /**
   * In minutes.
   */
  readingTime: number;
  summary?: React.ReactNode;
  content: React.ReactNode;
  linkedPages?: (store: PageStore) => Page[];
  maxWidth?: boolean;
}

export type PageHierarchyInformation = {
  title: TranslationKey;
  path: PageRoutes;
};

export interface PageHierarchyItem extends PageHierarchyInformation {
  children: PageHierarchyInformation[];
}

export const getPageMeta = (page: Page, t: TFunction<['home', 'common']>) => {
  return [
    { title: `${t(page.title)} - Kumbh Sukrit` },
    {
      name: 'description',
      content: typeof page.summary === 'string' ? page.summary : t(page.title),
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: `https://kumbhsukrit.com${page.path}`,
    },
  ];
};
